<template>
    <div class="modal-wz">
        <div class="modal-wrapper" @click="$emit('close')">
            <div class="modal-container" @click.stop>
                <div class="modal-header">
                    <slot name="header"></slot>
                 </div>

                <div class="modal-body">
                    <slot name="body"></slot>
                </div>

                <div class="modal-footer">
                    <slot name="footer"></slot>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'Modal',
        data () {
            return {

            };
        },
        created(){

        },
        methods: {

        }
    }
</script>

<style>
.modal-wz {
    position: fixed;
    z-index: 9998;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, .5);
    transition: opacity .3s ease;
    overflow: auto;
}

.modal-wrapper {
    vertical-align: middle;
    padding: 10px;
}

.modal-container {
    max-width: 600px;
    margin: 0px auto;
    background-color: #fff;
    border-radius: 2px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
    transition: all .3s ease;
}
</style>


// WEBPACK FOOTER //
// src/components/Modal.vue